import GiftGoalWidget from '../../widgets/GiftGoalWidget';
import GoalWidget from '../../widgets/GoalWidget';
import { loadWidgetData, RELOAD_INTERVAL } from './common';

async function mountGoal(host, widget, onField) {
	const load = () => loadWidgetData(host, [ 'userData' ]);
	await widget.init(await load());

	host.onSettingsChange(s => widget.applySettings(s));
	host.onFieldChange(onField);

	async function reload() {
		const d = await load();
		widget.applyUserData(d.userData);
		widget.applySettings(d.settings);
	}

	host.subscribe({ reconnect: reload });
	host.every(reload, RELOAD_INTERVAL);
	host.onDestroy(() => widget.destroy());
}

export function mountGiftGoal(host) {
	const widget = new GiftGoalWidget({ container: host.container });
	return mountGoal(host, widget, (field, value) => {
		if(field === 'amount') widget.setAmount(parseFloat(value || 0) || 0);
		else if(field === 'goal') widget.setGoal(parseFloat(value || 0) || 0);
		else widget.applySettings({ ...widget.settings, [field]: value });
	});
}

// Membership goal and follower goal share the same widget and count-based fields.
export function mountCountGoal(host) {
	const widget = new GoalWidget({ container: host.container });
	return mountGoal(host, widget, (field, value) => {
		if(field === 'count') widget.applySettings({ ...widget.settings, count: parseInt(value || 0) || 0 });
		else if(field === 'goal') widget.setGoal(parseInt(value || 0) || 0);
		else widget.applySettings({ ...widget.settings, [field]: value });
	});
}
